var session = require('../auth/models/session');

function isEnabled(value) {
  return value === true || value === 1 || value === '1';
}

function canWriteColumn(column) {
  if (session.isSuperuser()) {
    return true;
  }

  return !!(column && column.permission && isEnabled(column.permission.write));
}

module.exports = canWriteColumn;
